export var transitionendSubscriber = function (elm, event) {
    elm.addEventListener('transitionend', event);
    elm.addEventListener('transitioncancel', event);
    return function () {
        elm.removeEventListener('transitionend', event);
        elm.removeEventListener('transitioncancel', event);
    };
};
